import React from 'react';
import ContactForm from '../components/ContactForm';
import fotoVinha3 from '../assets/foto_vinha3.jpg';
import { useT } from '../i18n/LanguageContext';

const PHONE_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M3 5.5C3 4.67 3.67 4 4.5 4h1.46c.35 0 .66.22.78.55l.98 2.61c.14.37.03.79-.27 1.04L6.3 9.17a9.04 9.04 0 004.53 4.53l.97-1.15c.25-.3.67-.41 1.04-.27l2.61.98c.33.12.55.43.55.78V15.5c0 .83-.67 1.5-1.5 1.5C7.14 17 3 12.86 3 7.5v-2z" stroke="currentColor" strokeWidth="1.2" fill="none"/>
  </svg>
);

const EMAIL_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <rect x="2" y="5" width="16" height="12" rx="1" stroke="currentColor" strokeWidth="1.2" fill="none"/>
    <path d="M2 7l8 5 8-5" stroke="currentColor" strokeWidth="1.2"/>
  </svg>
);

export default function Contacto() {
  const t = useT();

  const INFO = [
    { icon: EMAIL_ICON, label: t('contacto.info.email'),   value: 'info@douronostrum.pt', href: 'mailto:info@douronostrum.pt' },
    { icon: PHONE_ICON, label: t('contacto.info.address'), value: 'Rua Vasco da Gama 43\n5160-297 Torre de Moncorvo' },
  ];

  return (
    <div className="page-top">

      {/* ── Header ── */}
      <section
        style={{
          background: `linear-gradient(160deg, rgba(14,7,4,0.65) 0%, rgba(14,7,4,0.35) 100%), url(${fotoVinha3}) center/cover no-repeat`,
          paddingTop: 'calc(var(--nav-height) + var(--sp-16))',
          paddingBottom: 'var(--sp-16)',
        }}
      >
        <div className="container">
          <div style={{ maxWidth: '560px' }}>
            <p className="t-label" style={{ color: '#ffffff', marginBottom: 'var(--sp-4)' }}>
              {t('contacto.eyebrow')}
            </p>
            <h1 className="t-h1 t-white" style={{ marginBottom: 'var(--sp-5)', textTransform: 'uppercase' }}>
              {t('contacto.title')}
            </h1>
            <p className="t-body-lg" style={{ color: 'rgba(255,255,255,0.7)' }}>
              {t('contacto.lead')}
            </p>
          </div>
        </div>
      </section>


      {/* ── Corpo principal ── */}
      <section className="section">
        <div className="container">
          <div className="grid-2" style={{ gap: 'var(--sp-16)', alignItems: 'start' }}>

            {/* ── Informações ── */}
            <div>
              <p className="t-label" style={{ color: '#000000', marginBottom: 'var(--sp-6)' }}>
                <span className="overline" />
                {t('contacto.info.title')}
              </p>

              <ul style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-6)' }}>
                {INFO.map(({ icon, label, value, href }) => (
                  <li
                    key={label}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 'var(--sp-4)',
                      paddingBottom: 'var(--sp-6)',
                      borderBottom: 'var(--border-thin)',
                    }}
                  >
                    <span
                      style={{
                        width: 40,
                        height: 40,
                        flexShrink: 0,
                        border: '1px solid #000000',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#000000',
                      }}
                    >
                      {icon}
                    </span>
                    <div>
                      <p className="t-label" style={{ color: 'rgba(0,0,0,0.6)', marginBottom: 'var(--sp-2)' }}>
                        {label}
                      </p>
                      {href ? (
                        <a
                          href={href}
                          className="t-body"
                          style={{
                            color: '#000000',
                            transition: 'color var(--dur-fast)',
                          }}
                          onMouseEnter={e => e.target.style.color = '#444444'}
                          onMouseLeave={e => e.target.style.color = '#000000'}
                        >
                          {value}
                        </a>
                      ) : (
                        <p className="t-body" style={{ whiteSpace: 'pre-line' }}>{value}</p>
                      )}
                    </div>
                  </li>
                ))}
              </ul>

              {/* Mapa Google Maps */}
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3018.9851729238765!2d-7.267199923754883!3d41.19458377133917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd41256e4c7c7c7cd%3A0x1234567890abcdef!2sRua%20Vasco%20da%20Gama%2043%2C%205160-297%20Torre%20de%20Monçorvo!5e0!3m2!1spt-PT!2spt!4v1715189765461"
                style={{
                  marginTop: 'var(--sp-8)',
                  height: '200px',
                  width: '100%',
                  border: 'var(--border-thin)',
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* ── Formulário ── */}
            <div>
              <p className="t-label" style={{ color: '#000000', marginBottom: 'var(--sp-6)' }}>
                <span className="overline" />
                {t('contacto.form.title')}
              </p>
              <ContactForm
                onSubmit={(data) => {
                  // Aqui integras com o teu backend / serviço de email
                  console.log('Formulário submetido:', data);
                }}
              />
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
